export default __webpack_public_path__ + "static/media/wishlistBlue.ad24e6af.svg";